import {
  CREATE_BUSINESS_EMAIL_TEMPLATE,
  CREATE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  CREATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  DELETE_BUSINESS_EMAIL_TEMPLATE,
  DELETE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  DELETE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  GET_BUSINESS_EMAIL_TEMPLATE_DETAILS, GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_FAIL,
  GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_SUCCESS,
  GET_BUSINESS_EMAIL_TEMPLATES,
  GET_BUSINESS_EMAIL_TEMPLATES_FAIL,
  GET_BUSINESS_EMAIL_TEMPLATES_SUCCESS,
  RESET_LIST_BUSINESS_EMAIL_TEMPLATES,
  UPDATE_BUSINESS_EMAIL_TEMPLATE,
  UPDATE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  UPDATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS
} from "./actionTypes";

const INIT_STATE = {
  list: {
    items: [],
    totalCount: 0,
    columnsVisible: null,
    params: {
      perPage: 10,
      currentPage: 1,
      columnFilter: {}, // Column filter
      keywords: "" // Input search all
    }
  },
  details: null,
  loadingList: false,
  loadingDetails: false,
  errorList: null,
  errorDetails: null
};

const businessEmailTemplatesData = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BUSINESS_EMAIL_TEMPLATES:
      return {
        ...state,
        loadingList: true
      };
    case GET_BUSINESS_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        loadingList: false,
        list: {
          ...state.list,
          items: action.payload.items.items,
          params: {
            ...state.params,
            ...action.payload.items._meta
          },
          totalCount: action.payload._meta
            ? action.payload.items._meta.totalCount
            : action.payload.items.items.length
        }
      };
    case GET_BUSINESS_EMAIL_TEMPLATES_FAIL:
      return {
        ...state,
        loadingList: false,
        errorList: action.payload.error
      };

    case GET_BUSINESS_EMAIL_TEMPLATE_DETAILS:
      return {
        ...state,
        loadingDetails: true
      };
    case GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_SUCCESS:
      return {
        ...state,
        loadingDetails: false,
        details: action.payload.emailTemplate
      };
    case GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_FAIL:
      return {
        ...state,
        loadingDetails: false,
        errorDetails: action.payload.error
      };

    case CREATE_BUSINESS_EMAIL_TEMPLATE:
      return {
        ...state,
        loadingDetails: true
      };
    case CREATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loadingDetails: false,
        list: {
          ...state.list,
          items: state.list.items.push(action.payload.emailTemplate)
        }
      };
    case CREATE_BUSINESS_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        loadingDetails: false,
        errorDetails: action.payload.error,
      };

    case UPDATE_BUSINESS_EMAIL_TEMPLATE:
      return {
        ...state,
        loadingDetails: true
      };
    case UPDATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS:
      const items = state.list.items;
      let updatedEmailTemplate = items.find((template) =>
        template.id === action.payload.emailTemplate.id);
      updatedEmailTemplate = action.payload.emailTemplate

      return {
        ...state,
        loadingDetails: false,
        list: {
          ...state.list,
          items
        }
      };
    case UPDATE_BUSINESS_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        loadingDetails: false,
        errorDetails: action.payload.error,
      };

    case DELETE_BUSINESS_EMAIL_TEMPLATE:
      return {
        ...state,
        loadingDetails: true
      };
    case DELETE_BUSINESS_EMAIL_TEMPLATE_SUCCESS:

      let newItems = state.list.items.filter((template) =>
        template.id !== action.payload.emailTemplateId);


      return {
        ...state,
        loadingDetails: false,
        list: {
          ...state.list,
          items: newItems
        }
      };
    case DELETE_BUSINESS_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        loadingDetails: false,
        errorDetails: action.payload.error,
      };

    case RESET_LIST_BUSINESS_EMAIL_TEMPLATES:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            columnFilter: {},
            keywords: ""
          }
        }
      };

    default:
      return { ...state };
  }
};

export default businessEmailTemplatesData;
